import { storyData } from '../building-future/climate-change';
import {
  BoardCommonControllerService,
  BoardVo,
} from '@/__generated__/CommonApi';
import CardImg1 from '@/assets/img/nodiscrimination/wash_card_img1@2x.jpg';
import CardImg2 from '@/assets/img/nodiscrimination/wash_card_img2@2x.jpg';
import CardImg3 from '@/assets/img/nodiscrimination/wash_card_img3@2x.jpg';
import WedoIco1 from '@/assets/img/nodiscrimination/wash_obj1_1@2x.png';
import WedoIco2 from '@/assets/img/nodiscrimination/wash_obj1_2@2x.png';
import WedoIco34 from '@/assets/img/nodiscrimination/wash_obj1_6@2x.png';
import WedoIco31 from '@/assets/img/nodiscrimination/wash_obj2020_1@2x.png';
import WedoIco32 from '@/assets/img/nodiscrimination/wash_obj2020_2@2x.png';
import WedoIco3 from '@/assets/img/nodiscrimination/wash_obj2_1@2x.png';
import WedoIco4 from '@/assets/img/nodiscrimination/wash_obj2_2@2x.png';
import WedoIco33 from '@/assets/img/nodiscrimination/wash_obj2_4@2x.png';
import WashTargetObj from '@/assets/img/nodiscrimination/wash_sec2_obj2@2x.png';
import WashTargetObjM from '@/assets/img/nodiscrimination/wash_sec2_obj2M@2x.png';
import AccordionComponent, { AccordionItem } from '@/components//Accordion';
import { CampaignData } from '@/components/Card/CampaignCard';
import RelativeBoardCard from '@/components/Card/RelativeBoardCard';
import Container from '@/components/Container';
import Image from '@/components/Image';
import LinkSafe from '@/components/LinkSafe';
import {
  SectionCard,
  SectionStroy,
  SectionTarget,
  SectionTop,
  SectionWedo,
} from '@/components/Nodiscrimination';
import PageComponent from '@/components/PageComponent';
import { ProcessList } from '@/components/ProcessList';
import Section, { SectionNews } from '@/components/Section';
import { breakpoint } from '@/helpers/BreakpointHelper';
import SectionHeader from '@/components/SectionHeader';
import SwiperBasic from '@/components/Swiper/SwiperBasic';
import ThumbnailFlex from '@/components/ThumbnailFlex';
import { Tit } from '@/components/Titles';
import YoutubeSingle from '@/components/YoutubeSingle';
import LayoutWithTitle from '@/layouts/LayoutWithTitle';
import { PageProps } from 'gatsby';
import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/components/scrollbar/scrollbar.min.css';
import { Swiper, SwiperSlide } from 'swiper/react';

const QnaNavigationButton = styled.div`
  padding: 24px 48px 24px 24px;
  cursor: pointer;
  font-weight: bold;
  font-size: 20px;
  position: relative;
  ${breakpoint(`mobile`)} {
    font-size: 16px;
    padding: 20px 40px 20px 0;
  }
`;
const QnaAccordionBody = styled.div`
  padding: 24px;
  font-size: 16px;
  color: #2d2926;
  line-height: 1.7;
  ${breakpoint(`mobile`)} {
    font-size: 14px;
    padding: 16px 0;
  }
  a {
    color: #1cabe2;
  }
`;

const card = [
  {
    id: 1,
    title: `커뮤니티 역량 강화`,
    alt: `커뮤니티 역량 강화, 세계 손씻기의 날 캠페인 현장, 유니세프 후원`,
    dec: `유니세프는 매년 수억 명을 대상으로 하는 '세계 손씻기의 날(Global Handwashing Day)' 캠페인처럼 지역사회를 기반으로 기본적인 위생 습관에 대해 홍보합니다. 지역사회를 기반으로 한 접근 방식은 공개 배변에 대한 위험성을 널리 알리고 개선하는 데 큰 도움이 됐습니다.`,
    img: CardImg1,
  },
  {
    id: 2,
    title: `학교 지원`,
    alt: `학교 지원, 물과 위생 및 손씻기 시설 접근성 개선, 안전한 위생시설을 활용 하는 어린이`,
    dec: `유니세프는 학교 및 의료 시설과 직접 협력하여 기본적인 물과 위생 및 손 씻기 시설에 대한 접근성을 개선하고 감염 예방 및 통제 프로토콜을 수립합니다. 생리대 처리 시설 등 개인이 이용할 수 있는 안전한 위생 시설을 설치하여 학교 보건 위생을 지원합니다. 또한 여자 어린이가 월경 주기에 대해 이해하고 관리할 수 있도록 교육 및 지원 서비스를 제공합니다.`,
    img: CardImg2,
  },
  {
    id: 3,
    title: `지속 가능성 고려`,
    alt: `지속 가능성 고려, 태양열 급수 시스템을 활용하는 모습, 유니세프 후원`,
    dec: `유니세프는 2021년 말까지 모든 식수와 위생 프로그램(Water, Sanitation and Hygiene; WASH)을 지속 가능하고 기후 변화에 탄력적으로 대응할 수 있도록 개선하는 작업을 추진하고 있습니다. 유니세프는 어린이를 위한 식수와 위생 프로그램 지원 외에도 물 부족 문제를 해결하기 위해 태양열 급수 시스템을 1,000개 이상 설치하거나 보수했습니다.`,
    img: CardImg3,
  },
];

const wedo = [
  {
    id: 1,
    tit: `2021년 주요 성과`,
    child: [
      {
        id: 1,
        img: WedoIco3,
        desc: [
          {
            dec: `<strong>106개국</strong>에 손 씻기 프로그램 지원 (목표치 <strong>78개국</strong> 초과 달성)`,
          },
        ],
      },
      {
        id: 2,
        img: WedoIco31,
        desc: [
          {
            dec: `<strong>1,600만 명</strong>에게 안전한 식수 제공`,
          },
        ],
      },
      {
        id: 3,
        img: WedoIco32,
        desc: [
          {
            dec: `<strong>1,990만 명</strong>에게 화장실, 세면대 등 공공 위생 서비스 제공`,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    tit: `2022년 주요 성과`,
    child: [
      {
        id: 1,
        img: WedoIco4,
        desc: [
          {
            dec: `<strong>2,600만 명</strong>에게 화장실, 세면대 등 기본 위생 서비스 제공`,
          },
        ],
      },
      {
        id: 2,
        img: WedoIco31,
        desc: [
          {
            dec: `<strong>3,060만 명</strong>에게 안전한 물 제공`,
          },
        ],
      },
      {
        id: 3,
        img: WedoIco3,
        desc: [
          {
            dec: `<strong>540만 명</strong>에게 기후변화에 강한 수도 시스템 제공`,
          },
        ],
      },
      {
        id: 4,
        img: WedoIco34,
        desc: [
          {
            dec: `태양열로 운영되는 에너지 공급시스템 <strong>1,855개</strong> 설치`,
          },
        ],
      },
      {
        id: 5,
        img: WedoIco33,
        desc: [
          {
            dec: `30개국을 강타한 수인성 질병, 콜레라에 대응`,
          },
        ],
      },
    ],
  },
  {
    id: 3,
    tit: `2023년 주요 성과`,
    child: [
      {
        id: 1,
        img: WedoIco3,
        desc: [
          {
            dec: `학교 <strong>7,500곳</strong> 이상과 의료시설 <strong>3,000곳</strong>에 식수와 위생 서비스 제공`,
          },
        ],
      },
      {
        id: 2,
        img: WedoIco34,
        desc: [
          {
            dec: `<strong>85개국</strong>에 어린이 중심 재난 대비 제도를 갖추도록 지원`,
          },
        ],
      },
      {
        id: 3,
        img: WedoIco33,
        desc: [
          {
            dec: `<strong>8개국</strong>에서 세계 최초로 <br/>사이클론 보험 운영`,
          },
        ],
      },
    ],
  },
  {
    id: 4,
    tit: `2024년 주요 성과`,
    child: [
      {
        id: 1,
        img: WedoIco4,
        desc: [
          {
            dec: `<strong>1,800만 명</strong> 이상에게<br/>기본적 위생 시설 접근`,
          },
        ],
      },
      {
        id: 2,
        img: WedoIco31,
        desc: [
          {
            dec: `<strong>3,300만 명</strong> 이상에게<br/>안전한 식수 서비스 이용`,
          },
        ],
      },
      {
        id: 3,
        img: WedoIco32,
        desc: [
          {
            dec: `<strong>2,100만 명</strong> 이상에게<br/>기본 개인위생 관리 서비스 지원`,
          },
        ],
      },
      {
        id: 4,
        img: WedoIco3,
        desc: [
          {
            dec: `학교 <strong>9,000개</strong>,<br/>보건의료 시설 <strong>4,000개</strong>의<br/>기본 수준의 위생시설 서비스 지원`,
          },
        ],
      },
      {
        id: 5,
        img: WedoIco33,
        desc: [
          {
            dec: `인도적 위기 상황에서의<br/>WASH 서비스는<br/><strong>30개국</strong> <strong>4,100만 명</strong> 제공`,
          },
        ],
      },
    ],
  },
  {
    id: 5,
    tit: `2025년 주요 성과`,
    child: [
      {
        id: 1,
        img: WedoIco4,
        desc: [
          {
            dec: `<strong>1,700만 명</strong> 이상에게<br/>기본 위생 시설 제공`,
          },
        ],
      },
      {
        id: 2,
        img: WedoIco31,
        desc: [
          {
            dec: `<strong>3,400만 명</strong> 이상에게<br/>안전한 식수 이용 지원`,
          },
        ],
      },
      {
        id: 3,
        img: WedoIco32,
        desc: [
          {
            dec: `<strong>1,500만 명</strong> 이상에게<br/>기본적인 개인 위생 서비스 제공`,
          },
        ],
      },
      {
        id: 4,
        img: WedoIco3,
        desc: [
          {
            dec: `<strong>5,500개</strong> 이상의 학교와<br/><strong>2,800개</strong> 이상의 보건의료시설에<br/>식수·위생 서비스 제공`,
          },
        ],
      },
    ],
  },
];

const NavigationButton = styled.div``;

const Wash: React.FC<PageProps> = ({ location }) => {
  const [slideData, setSlideData] = useState<storyData[]>([]);
  const [thumbs, setThumbs] = useState<CampaignData[]>([]);

  const loadSlideData = useCallback(async () => {
    try {
      const {
        data: childStory,
      } = await BoardCommonControllerService.foListAllUsingGet({
        boardCategoryCode: ['ST04'],
        outDateDispYn: `Y`,
      });
      setSlideData(
        childStory.map((story: BoardVo) => ({
          id: story.boardIndexNumber,
          subject: story.subject,
          contents: story.contents,
          optData1: story.optData1,
          image: story.imgAttGrpNoTn,
        })),
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  const loadThumbs = useCallback(async () => {
    try {
      const { data } = await BoardCommonControllerService.foListUsingGet({
        boardCategoryCode: ['280', '285', '290'],
        pagePerCount: 8,
        category: ['A003'],
      });
      const articles = data as any;
      setThumbs(
        articles
          .map((article: BoardVo) => ({
            id: article.boardIndexNumber,
            title: article.subject,
            pcImage: article.imgAttGrpNoTn,
            mobileImage: article.imgAttGrpNoTn,
            link: `/what-we-do/news/${article.boardIndexNumber}`,
            date: article.firstRegisterDate,
            boardCategoryCode: article.boardCategoryCode,
          }))
          .sort((a, b) => new Date(b.date) - new Date(a.date) || b.id - a.id),
      );
    } catch (e) {
      console.error(e);
    }
  }, []);

  useEffect(() => {
    loadSlideData();
    loadThumbs();
  }, [loadSlideData, loadThumbs]);

  return (
    <LayoutWithTitle
      location={location}
      title="안전하고 지속 가능한 환경"
      description="for every child, a clean and safe environment"
    >
      <SectionTop className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1-5" color="sky" weight="normal">
                <PageComponent id="title1">
                  모든 어린이는 안전하고{` `}
                  <br className="small-hide" />
                  지속 가능한 기후와 환경에서{` `}
                  <br className="small-hide" />
                  자랄 권리가 있습니다
                </PageComponent>
              </Tit>
            </h2>
            <p className="head-dec">
              <PageComponent id="content1">
                유니세프는 모든 어린이가 안전하고 지속 가능한 환경을 누릴 수 있도록
                식수와 위생시설을 지원합니다. 아프리카 물부족 지역을 비롯해 농촌과 도시 지역에서
                깨끗한 식수 공급 시스템을 구축하고, 손 씻기와 같이 기본적인 위생 습관을 장려합니다.
                또한 재난 위험은 줄이고 회복력은 높이는 사업을 펼치고, 평화를 구축하고 기후 위기
                대응에 힘씁니다. 효과적인 지원을 위해 유니세프는 정부, 민간 부문, 학계,
                시민 단체 및 지역사회와 긴밀히 협력합니다.
              </PageComponent>
            </p>
          </SectionHeader>
        </Container>
        <PageComponent id="youtube1">
          <YoutubeSingle videoId="g2JvEilmmsg" />
        </PageComponent>
      </SectionTop>

      <SectionCard className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">깨끗한 식수와 위생 지원을 위해 유니세프는 어떤 일을 하나요?</Tit>
            </h2>
          </SectionHeader>
          <ThumbnailFlex thumbs={card} />
        </Container>
      </SectionCard>

      <SectionTarget className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc sec-header">
            <div className="col-header">
              <h2>
                <Tit size="s1">
                  2022-2025 <br />
                  유니세프 중점 사업 목표
                </Tit>
              </h2>
              <ul className="blit">
                <li>
                  안전한 식수 이용자 <strong>증가</strong>
                </li>
                <li>
                  안전한 위생 시설 이용자 <strong>증가</strong>
                </li>
                <li>
                  비위생적인 물과 위생 시설로 인한 5세 미만 사망률{' '}
                  <strong>감소</strong>
                </li>
              </ul>
            </div>
            <Image pcSrc={WashTargetObj} mobileSrc={WashTargetObjM} />
          </SectionHeader>
        </Container>
      </SectionTarget>

      <SectionWedo className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">
                모든 어린이의 안전하고 지속 가능한 환경을 위해,{' '}
                <br className="m-hide" /> 전 세계 파트너와 함께 유니세프가 한 일
              </Tit>
            </h2>
          </SectionHeader>

          <AccordionComponent initialKey={wedo[wedo.length - 1].id}>
            {wedo.map((row) => (
              <AccordionItem
                key={row.id}
                toggleKey={row.id}
                renderToggle={(onClick) => (
                  <NavigationButton
                    onClick={onClick}
                    className="accordion-opener"
                  >
                    {row.tit}
                  </NavigationButton>
                )}
              >
                <div className="accordion-body">
                  <ProcessList itemData={row.child} />
                </div>
              </AccordionItem>
            ))}
          </AccordionComponent>
        </Container>
      </SectionWedo>

      <SectionStroy className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <h2>
              <Tit size="s1">유니세프는 물부족 지역의 어린이의 삶을 어떻게 변화시키나요?</Tit>
            </h2>
          </SectionHeader>
        </Container>
        <div className="section-content">
          <div className="obj t1" />
          <div className="obj t2" />
          <Container>
            <div className="content-container">
              <SwiperBasic
                css={`
                  padding: 0;
                `}
              >
                <Swiper slidesPerView="auto" navigation>
                  {slideData.map((row) => (
                    <SwiperSlide key={row.id}>
                      <div className="story-flex">
                        <div className="col-img">
                          <Image pcSrc={row.image} mobileSrc={row.image} />
                        </div>
                        <div className="col-dec">
                          <header>
                            <Tit size="s4" color="white">
                              &ldquo;{row.subject}&rdquo;
                            </Tit>
                            {row.optData1 !== null && row.optData1 !== `` && (
                              <p> - {row.optData1} </p>
                            )}
                          </header>
                          <p className="dec">{row.contents}</p>
                        </div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </SwiperBasic>
            </div>
          </Container>
        </div>
      </SectionStroy>

      <Section
        css={`
          padding: 60px 0;
          ${breakpoint(`mobile`)} {
            padding: 40px 0;
          }
        `}
      >
        <Container>
          <AccordionComponent initialKey="wash-qna-1">
            <AccordionItem
              toggleKey="wash-qna-1"
              renderToggle={(onClick) => (
                <QnaNavigationButton
                  onClick={onClick}
                  className="accordion-opener"
                >
                  <h2>
                    Q. 물부족 해결을 위해 할 수 있는 일은 무엇인가요?
                  </h2>
                </QnaNavigationButton>
              )}
            >
              <QnaAccordionBody>
                <p>
                  유니세프 후원을 통해 아프리카 물부족 지역 등에 우물 설치, 태양열
                  급수 시스템 구축, 가정 수도 연결, 식수 정화제 보급에 도움을 줄 수
                  있습니다. 소액 기부로도 한 가정에 수도를 연결하거나 식수 펌프를
                  보수하여 수백 명의 어린이에게 깨끗한 물을 공급하는 데 보탬이
                  됩니다.
                </p>
                <p style={{ marginTop: '12px' }}>
                  ☞{' '}
                  <a href="/involve/individual/pledge">
                    정기후원 페이지 바로가기
                  </a>
                  <br />
                  ☞{' '}
                  <a href="/involve/individual/oneoff">
                    일시후원 페이지 바로가기
                  </a>
                </p>
              </QnaAccordionBody>
            </AccordionItem>
          </AccordionComponent>
        </Container>
      </Section>

      <SectionNews className="by-sub-main-layout">
        <Container>
          <SectionHeader className="with-desc">
            <div className="flex-middle">
              <h2>
                <Tit size="s1">최근 소식</Tit>
              </h2>
              <LinkSafe to="/what-we-do/news?category=A003" className="more">
                <span className="txt">더 보기</span>
              </LinkSafe>
            </div>
          </SectionHeader>
          {thumbs.length > 0 && (
            <RelativeBoardCard
              newslist={thumbs}
              isDate={false}
              isSwiper
              overflowHidden
            />
          )}
        </Container>
      </SectionNews>
    </LayoutWithTitle>
  );
};

export default Wash;
